const hotel = {
  availableMealPlans: "Verfügbare Speisepläne", // translated
  availableRoomsTypes: "Verfügbare Zimmertypen", // translated
  cancellationPolicy: "Stornierungsbedingungen", // translated
  freeCancellationAvailable: "Kostenlose Stornierung möglich", // translated
  nonRefundable: "Nicht rückzahlbar", // translated
  priceFor: "Preis für", // translated
  nights: "Nächte", // translated
  totalPrice: "Gesamtpreis", // translated
  seeAvailability: "Siehe Verfügbarkeit", // translated
  myProfile: "Mein Profil", // translated
  travelTrust: "Reisevertrauen", // translated
  signIn: "Anmelden", // translated
  searchNow: "Jetzt suchen", // translated
  policy: "Politik", // translated
  beddingType: "Bettwäschetyp", // translated
  room: "Zimmer", // translated
  hotelName: "Hotelname", // translated
  cxlPolicy: "CXL-Richtlinie", // translated
  cxlRules: "CXL-Regeln", // translated
  cancellationRules: "Stornierungsbedingungen", // translated
  reservationDate: "Reservierungsdatum", // translated
  maxPax: "Max Pax", // translated
};

export default hotel;
